import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxury%20fashion%20editorial%20flat%20lay%20with%20premium%20leather%20sneakers%2C%20cashmere%20hoodie%2C%20designer%20tote%20bag%2C%20gold%20watch%20and%20minimalist%20accessories%20artfully%20arranged%20on%20raw%20concrete%20surface%2C%20dramatic%20warm%20side%20lighting%20creating%20long%20soft%20shadows%2C%20muted%20earth%20tones%20with%20terracotta%20accents%2C%20high-end%20magazine%20cover%20aesthetic%2C%20scandinavian%20studio%20photography&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
          alt="Superbuy Spreadsheet shopping resources"
          title="Superbuy Spreadsheet - Smart Shopping Resources"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/20"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-24 md:pt-32 pb-20">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-black text-white leading-[1.05] mb-6">
            Superbuy<br />
            Spreadsheet<br />
            <span className="text-accent-400 italic">2026</span>
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
            Discover thousands of curated product finds, compare quality options, learn QC methods,
            and build your perfect Superbuy shopping list with our updated Superbuy Spreadsheet guides.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300"
            >
              Explore Superbuy Sheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <Link
              to="/article/what-is-superbuy-spreadsheet"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/25 transition-all duration-300"
            >
              Start Beginner Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex flex-wrap items-center gap-5 mt-10 text-white/70 text-xs md:text-sm">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line text-primary-400"></i> Updated Resources
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line text-primary-400"></i> Beginner Friendly
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line text-primary-400"></i> Shopping Guides
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line text-primary-400"></i> Safety Focused
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 md:bottom-16 left-0 w-full px-4 md:px-6">
        <p className="text-white/30 text-5xl md:text-7xl lg:text-8xl font-heading font-black tracking-tighter leading-none select-none">
          SMART SHOPPING STARTS HERE
        </p>
      </div>
    </section>
  );
}